import React, { useState, useContext, useEffect } from 'react'
import classes from './Dashboard.module.css'

import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'

import { Header } from './components/header'
import { SideBar } from './components/sidebar'

import { MdOutlineNotes } from 'react-icons/md'
import { VscMenu } from 'react-icons/vsc'

import { Outlet, useParams } from 'react-router-dom'


const Dashboard = () => {

  const [dropMenuIsVisible, setDropMenuIsVisible] = useState(false);
  const [showSideBar, setShowSideBar] = useState(true);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { user } = useSelector((state) => state.auth)

    useEffect(() => {
        if (!user) {
            navigate('/login')
        }
    }, [user, navigate])



  const toggleSidebar = () => {
    setShowSideBar(!showSideBar);
  }


  const params = useParams();
  const route = window.location.href;

  return (
    
      
    <div className={classes.dashboard_screen}> 

    {showSideBar

    ?
        <div className={classes.side_bar} >
            <SideBar setShow={setDropMenuIsVisible} setShowSideBar={setShowSideBar} show={dropMenuIsVisible} className={classes.sidebar} />
        </div>
        : null
    }
    
      
      <div className={classes.dashboard_sub_screen}>
        
          <div className={classes.dash_header}>
          <VscMenu size={'20px'} color='#fff' cursor={'pointer'}
          onClick={ toggleSidebar } />
              {/* <div className={classes.hamburger_menu} onClick={() => setDropMenuIsVisible(true)}>
                  <MdOutlineNotes size={'2.2rem'} />
              </div> */}
              <div className={classes.header_avatar}>{ params.sub ? null : <Header /> }</div>
                
          </div> 

          <main className={`${classes.dashboard_main_content} ${classes.main_container})`}>
            {/* <> Welcome {user && user.userEmail} </> */}

            {/* <div>

            {  
            route.includes("dashboard/resources")
                ? <>
                    <h2>Add Res</h2>
                
                </>
                    : route.includes("contact-me")
                        ? <Header header={'<Let`s talk/>'} />
                            : route.includes("my-github")
                                ? <Header header={'<The Codebase/>'} />
                                    : route.includes("my-projects")
                                        ? <Header header={'<Building Amazing Project/>'} />
                                            : null

        }

            </div> */}
            <Outlet />
          </main>
      </div>
    </div>
  )
}

export {Dashboard}